import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import AirtimeTable from './AirtimeTable';
import { getAirtimeHistoryAPI } from '../../../../Library/apis';
import { Breadcrumbs, H5 } from '../../../../AbstractElements';
import { useNavigate } from 'react-router';
import SubHeader from '../../Common/SubHeader';

const Airtimes = () => {

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        getAirtimeHistoryAPI().then(res => {
            setIsLoading(false);
            setData(res.body);
        }).catch(() => {
            setIsLoading(false);
        })
    }, [navigate])

    return (
        <Fragment>
            <Breadcrumbs mainTitle='Reports/Records' />
            <Container fluid={true}>
                <SubHeader title="Purchased Airtimes" data={data} />
                <Card>
                    <CardBody>
                        <AirtimeTable data={data} isLoading={isLoading} />
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    );
};

export default Airtimes;
